import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";


/**
 * React Carousel
 */
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

/**
 * Map
 */
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

/**
 * Storage
 */
import { storageService, storageCarousel } from "services/storage.jsx";

/**
 * Components
 */
import Header from "components/Header.jsx";
import Footer from "components/Footer.jsx";
import Card from "components/home/Card.jsx";
import Service from "components/home/Service.jsx";
import Form from "components/Form.jsx";

/**
 * Crée la vue de la page d'accueil.
 * @returns La page d'accueil.
 */
function Home() {
    const [scroll, setScroll] = useState(0);
    const contaienrsRef = useRef(null);
    const buttonRef = useRef(null);

    /**
     * Espionne le scroll.
     */
    window.addEventListener("scroll", () => {
        setScroll(window.scrollY);
    })

    /**
     * Affiche ou cache le bouton.
     */
    useEffect(() => {
        if (scroll > 0) {
            buttonRef.current.style.opacity = "1";
        } else {
            buttonRef.current.style.opacity = "0";
        }
    }, [scroll]);

    /**
     * Reviens en haut de page.
     */
    function handleButtonToTop() {
        window.scrollTo(0, 0);
    }
    

    return (
        <div className="home">
            <Header />

            <div onClick={() => handleButtonToTop()} ref={buttonRef} className="header-button">
                    <i className="fa-solid fa-chevron-up"></i>
            </div>

            <main>
                <section className="home-info">
                    <div>
                        <h1>Vape&Phone</h1>
                        <p>La qualité premium à prix discount !</p>
                        <div className="home-info-contact">
                            <Link to="contact">Contact</Link>
                        </div>
                    </div>
                </section>

                <section className="home-galery">
                    <div className="home-galery-top">
                        <h2>Nos Services</h2>
                        <p>Pour répondre à vos besoins</p>
                    </div>

                    <div className="home-galery-cards">
                        <Card
                            title="Cigarettes électronique et e-liquide"
                            text="Un service d'experts"
                            image={require("assets/images/cig_elec.jpg")}
                            alt="Une cigarettes électronique de vape&phone Orthez"
                        />

                        <Card
                            title="Réparation de téléphone et tablette"
                            text="Toujours prêts"
                            image={require("assets/images/reparation_tel.jpg")}
                            alt="Une réparation de téléphone par vape&phone Orthez"
                        />
                    </div>
                </section>

                <section className="home-about">
                    <div>
                        <p className="home-about-title">Qui sommes-nous</p>
                        <p className="home-about-text">
                            Rapide, efficace et minutieux, Vape&Phone vous propose un service de réparation de vos appareils 
                            de toutes marques adapté à vos besoins et votre budget . Notre équipe est prête à 
                            répondre à toutes les demandes, et gère chaque projet avec le professionnalisme 
                            attendu par nos clients. Nous souhaitons que nos clients soient satisfaits de notre 
                            travail. C'est pourquoi nous continuons à nous former et à nous perfectionner de 
                            jour en jour .
                        </p>
                    </div>
                </section>

                <section className="home-services">
                    <h2>Multi-Services</h2>
                    <p>Pour répondre à vos besoins</p>

                    <div ref={contaienrsRef} className="home-services-containers">
                        {
                            storageService.map((service, index) => (
                                <Service
                                    key={index}
                                    title={service.title}
                                    text={service.text}
                                    img={service.image.src}
                                    alt={service.image.alt}
                                />
                            ))
                        }
                    </div>
                </section>

                <section className="home-carousel">
                    <Carousel
                        showThumbs={false}
                        autoPlay={true}
                        infiniteLoop={true}
                        showStatus={false}
                        dynamicHeight={true}
                        autoFocus={true}
                        emulateTouch={true}
                        showArrows={false}
                    >
                        {
                            storageCarousel.map((element, index) => (
                                <div className="home-carousel-element" key={index}>
                                    <p>{element.author.split(" ")[0][0]}{element.author.split(" ")[1][0]}</p>
                                    <p>{element.title}</p>
                                    <p>{element.author}</p>
                                </div>
                            ))
                        }
                    </Carousel>
                </section>

                <section className="home-contact">
                    <h2>Contact</h2>
                    <p>Nous vous répondons en moins de 48H !</p>
                    <Form />
                </section>

                <section className="home-map">
                    <h2>Où sommes-nous ?</h2>
                    <MapContainer
                        id="map"
                        doubleClickZoom={false}
                        center={[43.4898332, -0.7943331]}
                        zoom={12.5}
                        scrollWheelZoom={false}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={[43.4898332, -0.7943331]}>
                            <Popup
                            >
                                <p className="home-map-marker-title">Vape&Phone | Orthez</p>
                                <a 
                                    className="home-map-marker-text"
                                    href="https://www.google.com/maps/dir//Vape%26Phone+Orthez,+48+Rue+Henriette+Lasserre,+64300+Orthez/@43.4898332,-0.7943331,20z/data=!4m9!4m8!1m0!1m5!1m1!1s0xd5693a902723e67:0x9b95c2da89e104e8!2m2!1d-0.7944263!2d43.4898434!3e0?entry=ttu" 
                                    rel="noreferrer" 
                                    target="_blank"
                                >
                                    48 Rue Henriette Lasserre, 64300, Orthez.
                                </a>
                            </Popup>
                        </Marker>
                    </MapContainer>
                </section>
            </main>

            <Footer />
        </div>
    )
}

export default Home;